export const normalizeEnterDeveloperMode = response => ({
    hasChangedPrompts: response.has_changed_prompts,
})
